/**
 * events - a super-basic Javascript (publish subscribe) pattern
 * Docs: https://gist.github.com/learncodeacademy/777349747d8382bfb722
 */
class Events{

  /**
   * Map of events
   */
  public events: { [eventName: string]: any[] } = {};

  /**
   * Subscribe to the event, when the event gets emitted
   * run the callback function.
   */
  public on(eventName: string, callbackFunction: any): void {
    this.events[eventName] = this.events[eventName] || [];
    this.events[eventName].push(callbackFunction);
  }

  /**
   * Unsubscribe from a event.
   */
  public off(eventName: string, callbackFunction: any): void {
    if (this.events[eventName]) {

      for (let i = 0; i < this.events[eventName].length; i++) {
        if (this.events[eventName][i] === callbackFunction) {
          this.events[eventName].splice(i, 1);
          break;
        }
      }
    }
  }

  /**
   * Emit a new event to all subscribers. Optionally pass data
   * to the callback function of the subscribers.
   */
  public emit(eventName: string, data?: any): void {
    if (this.events[eventName]) {
      this.events[eventName].forEach((fn) => fn(data));
    }
  }
}

/**
 * Creates a singleton object to be shared in multiple components
 */
export let events = new Events();
